var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8,4 H10.2 Q11,4 11,4.8 V9.7 Q11,10.5 10.2,10.5 H1.8 Q1,10.5 1,9.7 V4.8 Q1,4 1.8,4 Z M1.8,4.32 Q1.32,4.32 1.32,4.8 V9.7 Q1.32,10.18 1.8,10.18 H10.2 Q10.68,10.18 10.68,9.7 V4.8 Q10.68,4.32 10.2,4.32 Z M4.5,3 H7.5 L8,4 L4,4 Z M4.4,7.2 a1.6,1.6 0 1 1 3.2,0 a1.6,1.6 0 1 1 -3.2,0 Z M4.72,7.2 a1.28,1.28 0 1 0 2.56,0 a1.28,1.28 0 1 0 -2.56,0 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.d9ce692e7931a96ac0c6da28303c80af.svg";
export { ForwardRef as ReactComponent };